import { useNotificationContext } from '@/contexts/NotificationContext';
import { useCallback } from 'react';
import { NotificationType } from '@/contexts/NotificationContext';

export const useNotifications = () => {
  const { showNotification } = useNotificationContext();

  const showError = useCallback(
    (message: string, duration?: number) => {
      return showNotification({ message, type: 'error', duration });
    },
    [showNotification],
  );

  const showWarning = useCallback(
    (message: string, duration?: number) => {
      return showNotification({ message, type: 'warning', duration });
    },
    [showNotification],
  );

  const showSuccess = useCallback(
    (message: string, duration?: number) => {
      return showNotification({ message, type: 'success', duration });
    },
    [showNotification],
  );

  const showNotificationWithType = useCallback(
    (message: string, type: NotificationType, duration?: number) => {
      return showNotification({ message, type, duration });
    },
    [showNotification],
  );

  return {
    showError,
    showWarning,
    showSuccess,
    showNotification: showNotificationWithType,
  };
};
